import { render } from "./ShowAmpunHasil.vue?vue&type=template&id=6fa40aa0"
import script from "./ShowAmpunHasil.vue?vue&type=script&lang=js"
export * from "./ShowAmpunHasil.vue?vue&type=script&lang=js"

import "./ShowAmpunHasil.vue?vue&type=style&index=0&id=6fa40aa0&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__